<template>
    <div>
        <b-modal 
            v-model="mostrarModalAtualizarDataBaseReajustamento" 
            @hidden="fecharModal()" 
            size="md" 
            no-close-on-backdrop
        >
            <div slot="modal-title">Atualizar Data Base para Reajustamento</div>

            <b-row>
                <b-col>
                    <b-form-group>
                        <label class="required">Data base para reajustamento</label>
                        <date-picker 
                            v-model="dataBaseReajustamento" 
                            :config="$datePickerOptions" 
                            v-mask="'##/##/####'"
                            @input="$v.dataBaseReajustamento.$touch()"
                            :state="$v.dataBaseReajustamento.$error ? false : null"
                        />
                        <b-form-invalid-feedback v-if="!$v.dataBaseReajustamento.required && $v.dataBaseReajustamento.$dirty">
                            A Data base para reajustamento é obrigatória.
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <b-form-group>
                        <label>Justificativa</label>
                        <b-form-textarea 
                            v-model="justificativa" 
                            rows="3" 
                            max-rows="6" 
                            :no-resize="true"
                            @input="$v.justificativa.$touch()"
                            :state="$v.justificativa.$error ? false : null"
                        ></b-form-textarea>
                        <b-form-invalid-feedback v-if="!$v.justificativa.required && $v.justificativa.$dirty">
                            A Justificativa deve conter no máximo 500 caracteres
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>

            <div slot="modal-footer">
                <b-button 
                    ref="btnCancelar"
                    class="mr-2"
                    variant="secondary" 
                    @click.stop="fecharModal()" 
                >
                    Cancelar
                </b-button>

                <b-button 
                    ref="btnConfirmar"
                    variant="primary" 
                    :disabled="$v.$invalid"
                    @click.stop="confirmarAtualizarDataBaseReajustamento"
                >
                    Confirmar
                </b-button>
            </div>
        </b-modal>
    </div>
</template>
<script>
import PropostaPrecoServico from '../PropostaPrecoServico';
import { required, maxLength } from 'vuelidate/lib/validators'

export default {
    name: 'ModalAtualizarDataBaseReajustamento',
    props: {
        mostrarModal: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            mostrarModalAtualizarDataBaseReajustamento: false,
            dataBaseReajustamento: null,
            justificativa: '',
        }
    },
    computed: {
    },

    validations: {
        dataBaseReajustamento: {
            required
        },
        
        justificativa: {
            maxLength: maxLength(500)
        }
    },

    methods: {
        limparForm(){
            this.dataBaseReajustamento = null;
            this.justificativa = '';
            this.$v.$reset();
        },

        fecharModal() {
            this.mostrarModalAtualizarDataBaseReajustamento = false;
            this.limparForm();
            this.$emit('update:mostrarModal', this.mostrarModalAtualizarDataBaseReajustamento);
        },

        confirmarAtualizarDataBaseReajustamento() {
            this.$swal({
                title: 'Confirmação',
                html: `Deseja realmente Atualizar a Data Base para Reajustamento?`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.atualizarDataBaseReajustamento();
                }
            })
        },

        atualizarDataBaseReajustamento() {
            const dto = {
                dataBaseReajustamento: this.$moment(this.dataBaseReajustamento, 'DD/MM/YYYY').toISOString(),
                justificativa: this.justificativa
            }

            this.$store.dispatch('addRequest')

            PropostaPrecoServico.AtualizarDataBaseReajustamento(this.$route.params.propostaPrecoId, dto)
                .then(response => {
                    if (response.data.success) {
                        this.$toast.success('Data Base para Reajustamento atualizada com sucesso', 'Sucesso', this.$toastConfig.success);
                        this.fecharModal();
                        this.$emit('dataBaseReajustamentoAtualizada');
                    } else {
                        this.erros = response.errors || ['Erro ao atualizar data base para reajustamento'];
                        this.$toast.error(
                            'Erro ao atualizar data base para reajustamento!',
                            'Erro',
                            this.$toastConfig.error
                        );
                    }
                })
                .catch(error => {
                    console.error('Erro ao atualizar data base para reajustamento:', error);
                    this.erros = [`Erro ao atualizar data base para reajustamento: ${error}`];
                    this.$toast.error(
                        'Erro ao atualizar data base para reajustamento!',
                        'Erro',
                        this.$toastConfig.error
                    );
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest')
                });
        },

    },

    watch: {
        mostrarModal(newVal) {
            this.mostrarModalAtualizarDataBaseReajustamento = newVal;
        },
    }
}
</script>